import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%'
  }
})

export default useStyles
